import React, { useState } from 'react';
import ProgressJournal from './ProgressJournal';

function GoalList({ goals, onDeleteGoal }) {
  const [openJournalId, setOpenJournalId] = useState(null);

  const toggleJournal = (goalId) => {
    setOpenJournalId(openJournalId === goalId ? null : goalId);
  };

  if (!goals || goals.length === 0) {
    return (
      <p style={{
        textAlign: 'center',
        marginTop: '20px',
        color: '#888',
        fontStyle: 'italic',
      }}>
        No goals yet. Create your first GRIND goal above!
      </p>
    );
  }

  return (
    <div style={{ marginTop: '20px' }}>
      <h2 style={{
        fontFamily: 'Bangers, sans-serif',
        fontSize: 'clamp(1.5rem, 4vw, 2rem)',
        letterSpacing: '2px',
        color: '#fff',
        textAlign: 'center',
        marginBottom: '20px',
      }}>
        📋 Your GRIND Goals
      </h2>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {goals.map((goal, index) => (
          <div key={goal.id || index}>
            <div style={{
              backgroundColor: '#1a1a1a',
              borderRadius: openJournalId === goal.id ? '12px 12px 0 0' : '12px',
              padding: '20px',
              borderLeft: '4px solid #FFD700',
            }}>
              <h3 style={{
                color: '#FFD700',
                fontFamily: 'Bangers, sans-serif',
                fontSize: '1.4rem',
                letterSpacing: '1px',
                marginBottom: '12px',
              }}>
                {goal.title}
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '10px',
                marginBottom: '16px'
              }}>
                {goal.grounded && (
                  <div>
                    <span style={{ color: '#FFD700', fontSize: '0.85rem', fontWeight: 'bold' }}>G — Grounded</span>
                    <p style={{ color: '#ccc', fontSize: '0.9rem', margin: '4px 0 0 0' }}>{goal.grounded}</p>
                  </div>
                )}
                {goal.results && (
                  <div>
                    <span style={{ color: '#FFD700', fontSize: '0.85rem', fontWeight: 'bold' }}>R — Results</span>
                    <p style={{ color: '#ccc', fontSize: '0.9rem', margin: '4px 0 0 0' }}>{goal.results}</p>
                  </div>
                )}
                {goal.inFocus && (
                  <div>
                    <span style={{ color: '#FFD700', fontSize: '0.85rem', fontWeight: 'bold' }}>I — In Focus</span>
                    <p style={{ color: '#ccc', fontSize: '0.9rem', margin: '4px 0 0 0' }}>{goal.inFocus}</p>
                  </div>
                )}
                {goal.nextLevel && (
                  <div>
                    <span style={{ color: '#FFD700', fontSize: '0.85rem', fontWeight: 'bold' }}>N — Next-Level</span>
                    <p style={{ color: '#ccc', fontSize: '0.9rem', margin: '4px 0 0 0' }}>{goal.nextLevel}</p>
                  </div>
                )}
                {goal.deadline && (
                  <div>
                    <span style={{ color: '#FFD700', fontSize: '0.85rem', fontWeight: 'bold' }}>D — Deadline</span>
                    <p style={{ color: '#ccc', fontSize: '0.9rem', margin: '4px 0 0 0' }}>{goal.deadline}</p>
                  </div>
                )}
              </div>

              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <button
                  onClick={() => toggleJournal(goal.id)}
                  style={{
                    backgroundColor: openJournalId === goal.id ? '#fff' : '#FFD700',
                    color: '#000',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontSize: '0.95rem',
                    fontFamily: 'Bangers, sans-serif',
                    letterSpacing: '1px',
                    cursor: 'pointer',
                  }}
                >
                  {openJournalId === goal.id ? '✖ Close Journal' : '📓 View Journal'}
                </button>
                <button
                  onClick={() => onDeleteGoal(goal)}
                  style={{
                    backgroundColor: 'transparent',
                    color: '#888',
                    border: '1px solid #444',
                    borderRadius: '8px',
                    padding: '10px 20px',
                    fontSize: '0.95rem',
                    cursor: 'pointer',
                  }}
                >
                  🗑 Delete
                </button>
              </div>
            </div>

            {openJournalId === goal.id && (
              <div style={{
                backgroundColor: '#222',
                borderRadius: '0 0 12px 12px',
                padding: '24px',
                borderLeft: '4px solid #FFD700',
                borderTop: '1px solid #333',
              }}>
                <ProgressJournal goalId={goal.id} goalTitle={goal.title} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default GoalList;